import { Card, Typography, Box, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";

const StatCard = ({ title, value, icon, iconColor, subtitle, isLoading }) => {
    return (
        <Card sx={{
            padding: 1,
            paddingX: 2,
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'grey.300',
            backgroundColor: 'white',
            boxShadow: 'none',
            flex: '1 1 200px',
            minWidth: '200px',
            position: 'relative'
        }}>
            {/* Icon in top right corner */}
            {icon && (
                <Box sx={{
                    position: 'absolute',
                    top: 8,
                    right: 8,
                    zIndex: 1,
                    color: iconColor || 'text.secondary'
                }}>
                    {icon}
                </Box>
            )}
            <Typography variant="h6" sx={{ fontWeight: '400', marginBottom: 0 }}>
                {title}
            </Typography>
            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '48px' }}>
                    <CircularProgress size={24} />
                </Box>
            ) : (
                <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                    {value}
                </Typography>
            )}
            <Typography variant="p" sx={{ fontSize: '12px', color: 'grey' }}>
                {subtitle ? subtitle : ""}
            </Typography>
        </Card>
    );
};

StatCard.propTypes = {
    title: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    icon: PropTypes.node,
    iconColor: PropTypes.string,
    subtitle: PropTypes.string,
    isLoading: PropTypes.bool,
};

export default StatCard;

